"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAttrs = void 0;

var _ramda = require("ramda");

var getAttrs = function getAttrs(name, attrs) {
  return (0, _ramda.pathOr)({}, [name], attrs);
};

exports.getAttrs = getAttrs;